import { NavLink } from "react-router-dom";

import CadmusLogoImg from "@/assets/cadmus-logo.svg";

/**
 * Cadmus Logo Component
 */

export function CadmusLogo() {
  return (
    <NavLink to="">
      <img
        style={{ height: 40, width: 122 }}
        src={CadmusLogoImg}
        alt="cadmus logo"
      />
    </NavLink>
  );
}
